<!-- PAGE TITLE
        ================================================== -->
<section class="page-title-section bg-img cover-background top-position1 left-overlay-dark" data-overlay-dark="9"
         data-background="img/bg/bg-04.jpg"
         style="background-image: url(assets/img/bg/bg-04.jpg);">
    <div class="container">
        <div class="row text-center">
            <div class="col-md-12">
                <h1>VISION AND MISSION</h1>
            </div>
            <div class="col-md-12">
                <ul>
                    <li><a routerLink="/">Home</a></li>
                    <li><a href="#!">Vision and Mission</a></li>
                </ul>
            </div>
        </div>
    </div>
</section>


<!-- Blog Two Columns
        ================================================== -->
<section class="py-3 py-md-5">
    <div class="container">
        <div class="section-heading">
            <h2 class="h1 mb-0">Vision & Mission</h2>
        </div>
        <div class="row mt-n2-6">
            <div class="col-md-6 mt-2-6">
                <article class="blog-style1 position-relative d-block mb-0">
                    <div class="text-holder">
                        <div class="category-box">
                            <a href="#!">OUR VISION</a>
                        </div>
                        <div><p>We have a clear vision to bring positive change and transformative impact on society
                            through incredible achievements in learning, continual innovation in education, research,
                            entrepreneurship, and creativity. We are empowering our students to contribute to the
                            economic development and stability of our nation.
                        </p></div>

                        <ul>
                            <li>
                                To establish a school with strong professionalism, scientific learning, and high-quality
                                instruction.
                            </li>
                            <li>
                                An organization that smoothly integrates education and employment for the benefit of
                                students, employees, and society as a whole.
                            </li>
                            <li>
                                Through multidisciplinary study, international variety, and the adoption of best
                                practices, this institution will foster both individual greatness and group endeavors in
                                the tranquil Himalayan setting.
                            </li>
                        </ul>
                    </div>
                </article>
            </div>

            <div class="col-md-6 mt-2-6">
                <article class="blog-style1 position-relative d-block mb-0">
                    <div class="text-holder">
                        <div class="category-box">
                            <a href="#!">OUR MISSION</a>
                        </div>
                        <div><p>Being one of the leading educational institutes, we are on a mission to create a better
                            place for modern learners by providing an education that blends with skill-building,
                            innovation, and real-world experiences. We are working to nurture individuals who are not
                            just academically proficient but socially responsible.
                        </p></div>

                        <ul>
                            <li>
                                Creating a domain that inspires curiosity, exceptional thinking, and creativity and
                                makes us the first choice of students and faculty.
                            </li>
                            <li>
                                Our Programs are designed to meet the growing demand of modern workforce. Create
                                leadership that is assertive, efficient, and effective.
                            </li>
                            <li>
                                Shaping not only capable professionals but also responsible citizens who contribute to
                                cultural and economic development. We are hoping for positive change in society that is
                                possible by capable leaders.
                            </li>
                            <li>
                                Achieve academic excellence.
                            </li>
                        </ul>
                    </div>
                </article>
            </div>

            <div class="col-md-12 mt-2-6">
                <article class="blog-style1 position-relative d-block mb-0">
                    <div class="text-holder">
                        <div class="category-box">
                            <a href="#!">ARNI</a>
                        </div>
                        <div><p>The only university in this area that is linked to the industry's center is ARNI. There
                            isn't another university within a hundred kilometers or so. It must be recognized that a
                            university has a great deal of advantages over colleges, which rely on another institution
                            for a variety of guidance, control, exam administration, results, and credential issuance.
                            Students must attend the university department for a variety of questions and concerns,
                            which leads to needless waste of money, time, and energy.
                        </p>
                        </div>

                        <h3>ARNI Highlights:</h3>
                        <ul>
                            <li>
                                We are passionate about grooming students into upcoming leaders who are not only
                                professional but also human with high ethics and strong character.
                            </li>
                            <li>
                                We are counted among the top universities in Himachal Pradesh with the necessary
                                approvals and recognitions.
                            </li>
                            <li>
                                While talking about the campus, we offer top-notch infrastructure in terms of
                                Classrooms, Seminar Halls, and well well-stocked Library.
                            </li>
                            <li>
                                120-acre, multidisciplinary, lush, green campus with a breathtaking panoramic vista of
                                the Dhauladhar Mountain Ranges.
                            </li>
                            <li>
                                Excellent educational programs, taught by knowledgeable, reputable, and experienced
                                faculty, in a welcoming, multicultural setting.
                            </li>
                            <li>
                                Enables top-notch placements in renowned and prosperous sectors and businesses around
                                the nation.
                            </li>
                            <li>
                                Resources for learning and libraries connected to global electronic databases.
                            </li>
                            <li>
                                Computer and engineering labs that are well-equipped and equipped with educational
                                technology.
                            </li>
                            <li>
                                With the most advanced WI-FI campus, students can learn at their own pace and location.
                            </li>
                            <li>
                                A committed group of professors in charge.
                            </li>
                            <li>
                                With nearly all indoor and outdoor sports and recreational amenities, as well as
                                separate gyms for boys and girls to create a sense of "home away from home," the hostel
                                is well-equipped for both sexes.
                            </li>
                            <li>
                                A health center to handle staff and student emergency medical requirements.
                            </li>
                            <li>
                                A campus that does not allow smoking or tagging.
                            </li>
                            <li>
                                The majority of the surrounding areas have dedicated transportation infrastructure.
                            </li>
                        </ul>
                    </div>
                </article>
            </div>
        </div>
    </div>
</section>
